import type { FaireProductEntity } from "../../entity_types/product";

export const p_k9rpz8wyby: FaireProductEntity = {
  token: "p_k9rpz8wyby",
  type: "product",
  name: "Large Canvas Tote Bag - Courage is Beautiful",
  brandToken: "b_8iiyhdl1mw",
  brandName: "Faithworks by Creative Brands",
  imageUrl:
    "https://cdn.faire.com/fastly/583e5543dbc2d6cf4fb0f4f3419ed4b41e97002c8040c30921bea31e668b0134.jpeg",
  galleryImageUrls: [],
  priceDollars: 10.09,
  description:
    'Best-Selling large heavy duty canvas totes in new colors! Blush text on grey reads Courage is Beautiful.  Features inside pocket and waterproof lining for easy cleaning.\n\n• Material: Canvas, PU Lining, Leather\n• Size: 20"W x 11"H x 6"D, Pocket: 9"W x 7.5"H\n• Care Instructions: Spot Clean Only',
  tags: [],
  msrpDollars: 48,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T19:26:57.644Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
